import { createContext } from 'react'

export interface AppContextProps {
    page: string
}

export const AppContext = createContext<AppContextProps>(null)
